document.addEventListener('DOMContentLoaded', function() {
    const filterYear = document.querySelector('.js-filter-year');
    const filterTopic = document.querySelector('.js-filter-topic');
    const filterSource = document.querySelector('.js-filter-source');
    const articles = document.querySelectorAll('.js-press-archive-article');
    const loadMoreButton = document.querySelector('.js-load-more-button');
    const articlesSet = document.querySelector('[data-articles-set]');
    const paginateBy = articlesSet ? parseInt(articlesSet.getAttribute('data-articles-set')) : 2;

    function filterArticles() {
        const selectedYear = filterYear ? filterYear.value : '';
        const selectedTopic = filterTopic ? filterTopic.value : '';
        const selectedSource = filterSource ? filterSource.value : '';

        let visibleCount = 0;

        articles.forEach(function(article) {
            const articleYear = article.getAttribute('data-article-date') || '';
            const articleTopic = article.getAttribute('data-article-topic') || '';
            const articleSource = article.getAttribute('data-article-source') || '';

            const yearMatch = !selectedYear || articleYear === selectedYear;
            const topicMatch = !selectedTopic || articleTopic === selectedTopic;
            const sourceMatch = !selectedSource || articleSource === selectedSource;

            if (yearMatch && topicMatch && sourceMatch) {
                article.classList.remove('wls-press-archive__article--visible');
                article.style.display = '';
                
                // Show articles up to paginateBy limit
                if (visibleCount < paginateBy) {
                    article.classList.add('wls-press-archive__article--visible');
                    visibleCount++;
                }
            } else {
                article.classList.remove('wls-press-archive__article--visible');
                article.style.display = 'none';
            }
        });

        // Show/hide load more button based on remaining visible articles
        if (loadMoreButton) {
            const totalVisible = Array.from(articles).filter(function(article) {
                const articleYear = article.getAttribute('data-article-date') || '';
                const articleTopic = article.getAttribute('data-article-topic') || '';
                const articleSource = article.getAttribute('data-article-source') || '';

                const yearMatch = !selectedYear || articleYear === selectedYear;
                const topicMatch = !selectedTopic || articleTopic === selectedTopic;
                const sourceMatch = !selectedSource || articleSource === selectedSource;

                return yearMatch && topicMatch && sourceMatch;
            }).length;

            if (totalVisible > paginateBy) {
                loadMoreButton.closest('.wls-press-archive__articles-load-more').style.display = '';
            } else {
                loadMoreButton.closest('.wls-press-archive__articles-load-more').style.display = 'none';
            }
        }
    }

    // Add event listeners to filters
    if (filterYear) {
        filterYear.addEventListener('change', filterArticles);
    }
    if (filterTopic) {
        filterTopic.addEventListener('change', filterArticles);
    }
    if (filterSource) {
        filterSource.addEventListener('change', filterArticles);
    }

    // Load more functionality
    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function() {
            const selectedYear = filterYear ? filterYear.value : '';
            const selectedTopic = filterTopic ? filterTopic.value : '';
            const selectedSource = filterSource ? filterSource.value : '';

            const currentlyVisible = document.querySelectorAll('.js-press-archive-article.wls-press-archive__article--visible').length;
            let shownCount = 0;

            articles.forEach(function(article) {
                if (shownCount >= paginateBy) return;

                const articleYear = article.getAttribute('data-article-date') || '';
                const articleTopic = article.getAttribute('data-article-topic') || '';
                const articleSource = article.getAttribute('data-article-source') || '';

                const yearMatch = !selectedYear || articleYear === selectedYear;
                const topicMatch = !selectedTopic || articleTopic === selectedTopic;
                const sourceMatch = !selectedSource || articleSource === selectedSource;

                if (yearMatch && topicMatch && sourceMatch) {
                    if (!article.classList.contains('wls-press-archive__article--visible')) {
                        article.classList.add('wls-press-archive__article--visible');
                        shownCount++;
                    }
                }
            });

            // Hide load more button if all matching articles are shown
            const totalVisible = Array.from(articles).filter(function(article) {
                const articleYear = article.getAttribute('data-article-date') || '';
                const articleTopic = article.getAttribute('data-article-topic') || '';
                const articleSource = article.getAttribute('data-article-source') || '';

                const yearMatch = !selectedYear || articleYear === selectedYear;
                const topicMatch = !selectedTopic || articleTopic === selectedTopic;
                const sourceMatch = !selectedSource || articleSource === selectedSource;

                return yearMatch && topicMatch && sourceMatch;
            }).length;

            const currentlyVisibleAfter = document.querySelectorAll('.js-press-archive-article.wls-press-archive__article--visible').length;

            if (currentlyVisibleAfter >= totalVisible) {
                loadMoreButton.closest('.wls-press-archive__articles-load-more').style.display = 'none';
            }
        });
    }
});

